const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  display: flex;
  font: var(--goto-body-medium);
  color: var(--goto-text-01);
}

:host([hidden]) {
  display: none;
}`; export default styles;